import { render, staticRenderFns } from "./ShowAvatar.vue?vue&type=template&id=4f2da789&scoped=true"
import script from "./ShowAvatar.vue?vue&type=script&lang=js"
export * from "./ShowAvatar.vue?vue&type=script&lang=js"
import style0 from "./ShowAvatar.vue?vue&type=style&index=0&id=4f2da789&prod&scoped=true&lang=css"
import style1 from "./ShowAvatar.vue?vue&type=style&index=1&id=4f2da789&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2da789",
  null
  
)

export default component.exports